import { FC, useState } from 'react'
import { useRouter } from 'next/router'
import styled from 'styled-components'
import { Close } from 'svgIcons'
import { Notification_SimpleNotificationFragment } from 'generated/graphql'
import ChatAppModal from '@app.components/modals/ChatAppModal/ChatAppModal'
import useIsWebview from '@app.modules/hooks/useIsWebview'
import { convertCreatedAtToString } from '@app.modules/util/time'
import { getTypeData } from './NotificationCard'
import {
  handleClickDeleteNotificationType,
  handleClickNotificationType,
} from './NotificationCard.types'

interface IFProps {
  data: Notification_SimpleNotificationFragment
  onClick: handleClickNotificationType
  onClickDelete: handleClickDeleteNotificationType
}

const NotificationCardMobile: FC<IFProps> = ({
  data,
  onClick,
  onClickDelete,
}) => {
  const router = useRouter()
  const isWebview = useIsWebview()
  const typeData = getTypeData(data.__typename)
  const [isAppModalOpen, setIsAppModalOpen] = useState(false)

  const handleClickNotification = (
    data: Notification_SimpleNotificationFragment,
  ) => {
    onClick(data.id)

    if (data?.__typename === 'ChatMessageReplyNotification') {
      isWebview
        ? router.push(`/?${data?.linkUrl.split('?')[1]}`)
        : setIsAppModalOpen(true)
    } else {
      router.push(data.linkUrl)
    }
  }

  return (
    <StyledWrapper data-unread={data.unread}>
      <div className="lt" onClick={() => handleClickNotification(data)}>
        <div className="dot" />
        <div className="content">
          <div className="noti-title">{data.title}</div>
          <div className="noti-subtitle">{data.content}</div>
          <div className="noti-desc">
            {typeData.category} <span>|</span>
            {convertCreatedAtToString(data.createdAt)}
          </div>
        </div>
      </div>
      <div className="rt" onClick={() => onClickDelete(data.id)}>
        <Close />
      </div>
      <ChatAppModal
        open={isAppModalOpen}
        onClose={() => setIsAppModalOpen(false)}
      />
    </StyledWrapper>
  )
}

export default NotificationCardMobile

const StyledWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 15px 20px;
  border-bottom: 1px solid #e8e8e8;
  background-color: white;
  &[data-unread='true'] {
    background-color: #f2faff;
    .lt {
      .dot {
        &::after {
          background-color: #01a0ff;
        }
      }
    }
  }
  .lt {
    overflow: hidden;
    display: flex;
    cursor: pointer;
    .dot {
      height: 24px;
      display: flex;
      align-items: center;
      margin-right: 10px;
      &::after {
        content: '';
        width: 9px;
        height: 9px;
        border-radius: 50%;
        background-color: #003056;
      }
    }
    .content {
      .noti-title {
        font-size: 16px;
        line-height: 24px;
      }
      .noti-subtitle {
        font-size: 16px;
        color: #999;
        margin-bottom: 5px;
        word-break: break-word;
      }
      .noti-desc {
        font-size: 12px;
        color: #999;
        span {
          padding: 0px 7px;
        }
      }
    }
  }
  .rt {
    display: flex;
    align-items: center;
    height: 24px;
    cursor: pointer;
  }
`
